<template>
  <div>
    <div
      v-if="order.groupOrder.token"
      :class="{
        'animation-slide-left': attemptedToCreateGroup
      }"
    >
      <div class="section center">
        <h1 class="title title--2 primary half-spacing">
          Invite Your Friends
        </h1>

        <p class="bigger extra-spacing">
          Share this group link with your friends:
        </p>

        <copy-to-clipboard
          name="groupOrderLink"
          label="Group Order Link"
          :value="order.groupOrder.link"
        />
      </div>

      <div class="section section--alt-background section--half-y-padding center">
        <div class="layout layout--horizontal layout--horizontal-equal">
          <button
            class="link link--margin danger"
            type="button"
            @click="cancelOrder"
          >
            Cancel Order
          </button>

          <button
            class="button button--secondary button--large"
            type="button"
            @click="browseMenu"
          >
            Browse Menu
          </button>
        </div>
      </div>
    </div>



    <validated-form
      v-else
      name="createGroup"
      @valid-submit="createGroup"
    >
      <div class="section center">
        <img
          class="illustration illustration--group-order extra-spacing"
          src="/images/illustrations/group-order-people.svg"
          role="presentation"
          alt=""
        >

        <h1 class="title title--2 primary half-spacing">
          Create a Group Order
        </h1>

        <p class="bigger">
          Share a cart with guests. As the host, you can checkout once everyone is ready.
        </p>
      </div>

      <template v-if="currentUser.accountId">
        <div class="section section--half-padding section--alt-background">
          <selected-location-order-details />

          <p class="smaller dark-gray">
            <i>You won’t be able to change these details once the group order is created.</i>
          </p>
        </div>

        <div class="section">
          <text-input
            v-model="hostName"
            type="text"
            label="Your Name"
            placeholder=""
            name="hostName"
            icon-class="fa-user"
            :validations="{
              max: 20,
              required: true
            }"
          />

          <button
            class="button button--primary button--large"
            :class="{
              'button--loading': creatingGroup
            }"
            type="submit"
          >
            Create Group Order
          </button>

          <div class="center">
            <button
              class="link link--margin"
              type="button"
              @click="$closeModal('editGroupOrder')"
            >
              Cancel
            </button>
          </div>
        </div>
      </template>



      <div
        v-else
        class="section section--alt-background center"
      >
        <button
          class="button button--primary button--large"
          type="button"
          @click="$openModal('signIn')"
        >
          Sign In
        </button>

        <div class="title-separator">
          <p class="title title--6 uppercase">
            or
          </p>
        </div>

        <button
          class="button button--secondary button--small button--auto-width"
          type="button"
          @click="$openModal('createAccount')"
        >
          Create Account
        </button>
      </div>
    </validated-form>
  </div>
</template>



<script>
  import errorHandlers from '@/services/error-handlers';
  import { mapGetters } from 'vuex';



  export default {
    name: 'EditGroupOrder',

    data() {
      return {
        attemptedToCreateGroup: false,
        creatingGroup: false,
        hostName: null
      };
    },

    computed: {
      ...mapGetters('orders', ['order']),
      ...mapGetters('session', ['currentUser'])
    },

    watch: {
      'currentUser.accountId': 'autofillDetails'
    },

    created() {
      this.createdHandler();
    },

    methods: {
      autofillDetails() {
        if (this.currentUser.accountId) {
          this.hostName = this.currentUser.firstName;
        }
      },

      browseMenu() {
        this.$closeModal('editGroupOrder');

        this.$router.push({
          name: 'orderMenu',
          params: {
            merchantId: this.$route.params.merchantId
          }
        });
      },

      cancelOrder() {
        this.$openModal('confirmation', {
          ctaConfirmText: 'Yes, Cancel',
          primaryText: 'All items and guests will be removed from your cart.',
          onConfirm: () => this.$store.dispatch('orders/cancelOrder'),
          onConfirmSuccess: () => {
            // this.$triggerGoogleTrackingEvent('CancelGroupOrder', 'GroupOrder');

            this.$triggerNewRelicEvent('CancelGroupOrder', 'Information', 'CancelGroupOrder');

            this.$closeAllModals();
          },
          title: 'Cancel group order?'
        });
      },

      createdHandler() {
        this.autofillDetails();
      },

      async createGroup() {
        try {
          this.attemptedToCreateGroup = true;
          this.creatingGroup = true;

          await this.$store.dispatch('orders/groupOrderCreate', {
            hostName: this.hostName
          });

          // this.$triggerGoogleTrackingEvent('CreateGroupOrderSuccess', 'GroupOrder');

          this.$triggerNewRelicEvent('CreateGroupOrderSuccess', 'Information', 'Create Group Order Success');
        }

        catch (error) {
          errorHandlers.generic(error);

          // this.$triggerGoogleTrackingEvent('CreateGroupOrderFailure', 'GroupOrder');

          this.$triggerNewRelicEvent('CreateGroupOrderFailure', 'Error', 'Create Group Order Failure');
        }

        finally {
          this.creatingGroup = false;
        }
      }
    }
  };
</script>
